<script>
  import debounce from '@/_legacy/directives/debounce';

  export default {
    name: 'ConductInspectionItemQuestionNumber',
    directives: {
      debounce,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    methods: {
      valueChanged(value) {
        const formattedValue = value.replace(',', '.');
        this.$emit('change', {
          uuid: this.item.uuid,
          response: formattedValue,
          responded: !!(value && value.length),
        });
      },
    },
  };
</script>

<template>
  <div>
    <input
      v-debounce="valueChanged"
      type="text"
      class="w-full form-control form-input form-input-bordered"
      :placeholder="$t('Enter number')"
      :value="item.response"
    >
  </div>
</template>
